"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        <li className="h-4 w-24 bg-muted animate-pulse" />
        <li className="h-4 w-20 bg-muted animate-pulse" />
        <li className="h-4 w-28 bg-muted animate-pulse" />
        <li className="h-4 w-16 bg-muted animate-pulse" />
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.slice(0, 5).map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/80 text-[0.9375rem] font-default hover:text-foreground transition-colors duration-200 relative inline-block group">
            <span>{item.label}</span>
            <span className="absolute left-0 -bottom-1 h-px w-0 bg-secondary transition-all duration-200 group-hover:w-full" />
          </Link>
        </li>)}
    </ul>;
}
const catalogueLinks = [{
  label: "Infrastructure",
  to: "/GuidancePage"
}, {
  label: "Treatment",
  to: "/GuidancePage"
}, {
  label: "Regulations",
  to: "/GuidancePage"
}, {
  label: "Maintenance",
  to: "/GuidancePage"
}, {
  label: "Resources",
  to: "/GuidancePage"
}];
const accountLinks = [{
  label: "Member Portal",
  to: "/SupportPage"
}, {
  label: "Report Issue",
  to: "/SupportPage"
}, {
  label: "Billing Help",
  to: "/SupportPage"
}, {
  label: "Service Map",
  to: "/SupportPage"
}];
const supportLinks = [{
  label: "Water Quality",
  to: "/SupportPage"
}, {
  label: "Emergency",
  to: "/SupportPage"
}, {
  label: "Committee",
  to: "/SupportPage"
}, {
  label: "Contact Us",
  to: "/SupportPage"
}];
const socialLinks = [{
  label: "Facebook",
  to: "#"
}, {
  label: "Twitter",
  to: "#"
}, {
  label: "Community",
  to: "#"
}];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="15145" id="footer" className="dark bg-background text-foreground py-28 md:py-32 font-default">
      <div className="mx-auto max-w-[1440px] px-5 md:px-8 lg:px-16">
        {}
        <div className="grid grid-cols-2 md:grid-cols-12 gap-x-4 md:gap-x-8 gap-y-12">
          {}
          <div className="col-span-2 md:col-span-12 lg:col-span-4">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-7 w-auto" />
            </Link>

            <p className="mt-8 max-w-sm text-[1rem] leading-[1.6] font-default text-foreground/70 font-light">
              Water Service Provider Guide provides reliable, community-focused resources for members, committees, and operators to ensure safe, sustainable water delivery.
            </p>

            <address className="mt-12 not-italic font-mono text-[0.8125rem] leading-[1.6] text-foreground/60 space-y-0.5">
              <div>{"100 Community Way"}</div>
              <div>{"Water District, ST 90210"}</div>
            </address>
          </div>

          {}
          <div className="col-span-1 md:col-span-3 lg:col-span-2">
            <div className="text-[0.75rem] uppercase font-medium tracking-[0.14em] text-foreground/50 mb-6 font-default">
              {"Guidance"}
            </div>
            <MenuProvider menu_id="34">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="col-span-1 md:col-span-3 lg:col-span-2">
            <div className="text-[0.75rem] uppercase font-medium tracking-[0.14em] text-foreground/50 mb-6 font-default">
              {"Support"}
            </div>
            <ul className="flex flex-col gap-3">
              {accountLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-foreground/80 text-[0.9375rem] font-default hover:text-foreground transition-colors duration-200 relative inline-block group">
                    <span>{item.label}</span>
                    <span className="absolute left-0 -bottom-1 h-px w-0 bg-secondary transition-all duration-200 group-hover:w-full" />
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="col-span-1 md:col-span-3 lg:col-span-2">
            <div className="text-[0.75rem] uppercase font-medium tracking-[0.14em] text-foreground/50 mb-6 font-default">
              {"Resources"}
            </div>
            <ul className="flex flex-col gap-3">
              {supportLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-foreground/80 text-[0.9375rem] font-default hover:text-foreground transition-colors duration-200 relative inline-block group">
                    <span>{item.label}</span>
                    <span className="absolute left-0 -bottom-1 h-px w-0 bg-secondary transition-all duration-200 group-hover:w-full" />
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="col-span-1 md:col-span-3 lg:col-span-2">
            <div className="text-[0.75rem] uppercase font-medium tracking-[0.14em] text-foreground/50 mb-6 font-default">
              {"Operations"}
            </div>
            <ul className="flex flex-col gap-3">
              {catalogueLinks.slice(0, 4).map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-foreground/80 text-[0.9375rem] font-default hover:text-foreground transition-colors duration-200 relative inline-block group">
                    <span>{item.label}</span>
                    <span className="absolute left-0 -bottom-1 h-px w-0 bg-secondary transition-all duration-200 group-hover:w-full" />
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="mt-16 h-px w-full bg-border" />

        {}
        <div className="mt-12 md:h-12 md:mt-0 md:pt-8 grid grid-cols-1 md:grid-cols-12 gap-y-4 items-center">
          <div className="md:col-span-6 font-mono text-[0.8125rem] text-foreground/60">
            <span>{`Water Service Provider Guide © ${currentYear}. All rights reserved.`}</span>
          </div>

          <div className="md:col-span-6 flex md:justify-end items-center">
            <ul className="flex items-center">
              {socialLinks.map((item, i) => <li key={item.label} data-index={i} className="flex items-center">
                  <Link to={item.to} className="text-foreground/80 text-[0.9375rem] font-default hover:text-foreground transition-colors duration-200 px-4 first:pl-0 last:pr-0 relative inline-block group">
                    <span className="relative">
                      {item.label}
                      <span className="absolute left-0 -bottom-1 h-px w-0 bg-secondary transition-all duration-200 group-hover:w-full" />
                    </span>
                  </Link>
                  {i < socialLinks.length - 1 && <span aria-hidden="true" className="block h-3 w-px bg-border" />}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}